import useSWR from 'swr'
import { useTranslation } from 'react-i18next'
import { LearningPathCard } from 'components/ui/LearningPathCard'
import { EmptyState } from 'components/learning-path'
import { paths } from 'routes/paths'
import Loader from 'components/ui/loader/Loader'
import learningPaths from 'api/learning-paths/get'
import styles from './LearningPaths.module.scss'

interface Props {
  search?: string
}

export const LearningPaths = ({ search }: Props) => {
  const { t } = useTranslation()

  const { data, isLoading } = useSWR(
    { key: 'learningPaths', search: search },
    async (arg) => learningPaths({ search: arg.search })
  )

  if (isLoading) return <Loader color />

  return (
    <div className={styles.learningPaths}>
      {data?.map((learningPath: any) => (
        <LearningPathCard
          key={learningPath.id}
          learningPath={learningPath}
          className={styles.learningPathCard}
        />
      ))}
      {!data ||
        (data.length === 0 && (
          <EmptyState
            text={t('learningPaths.section.empty')}
            link={{
              href: paths.library.root,
              text: t('emptyStates.redirectLibrary'),
            }}
          />
        ))}
    </div>
  )
}
